export default {
  leadEnteredCVC: 'lead entered cvc',
  leadCheckedMemberAgreement: 'lead checked member agreement',
  leadCheckedTermsAndConditions: 'lead checked terms and conditions',
  leadTriedAddingPromo: 'lead tried adding promo',
  leadTriedRemovingPromo: 'lead tried removing promo',
  leadSubmittedPaymentStep: 'lead submitted payment step',
  leadPaymentError: 'lead payment error',
  facetQuizEntered: 'entered facet quiz',
  facetQuizContactInfoSubmitted: 'submitted facet quiz contact info',
};
